import React, { useState ,useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 

import SuccessMsg from '../../Common/SuccessMsg';
import CommonAPI from '../../Common/CommonAPI';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 

 

function  StoMaintain (props)  { 
    
    var StandingOrderId = JSON.parse(sessionStorage.getItem("ActiveStandHis")).id;
    const [MainCustomerName,setMainCustomerName] = useState();
    const [Benename,setBenename] = useState();
    const [BeneBankAccountNum,setBeneBankAccountNum] = useState();
    const [BankAccountNum,setBankAccountNum] = useState();
    const [Frequency,setFrequency] = useState();
    const [Amount,setAmount] = useState();
    const [BeneBank,setBeneBank] = useState();
    const [BeneBranch,setBeneBranch] = useState();
    const [StartDate,setStartDate] = useState();
    const [YourReference,setYourReference] = useState();
    const [BeneReference,setBeneReference] = useState();
    const [Status,setStatus] = useState();
    const [ReferenceNumber,setReferenceNumber] = useState();
    const [Summary,setSummary] = useState([]);
    const [StartLoadingFinish,setStartLoadingFinish] = useState();
    const [SuccessLoading,setSuccessLoading] = useState(true);
    const [CancelPayment,setCancelPayment] = useState(false);
    const [ErrorMSG,setErrorMSG] = useState();
    const [SuccessMSG,setSuccessMSG] = useState(false);
    const [EnteredPassword,setEnteredPassword] = useState("");
    const [EditSTO,setEditSTO] = useState(false);
    const [AvialableBalance,setAvialableBalance] = useState();
    const [ExistFrequency,setExistFrequency] = useState();
    const [Recurring,setRecurring] = useState();
    const [EndDate,setEndDate] = useState(new Date());
    
     useEffect( () => {
        GetSTODetailsAPI();        
      },[]);
    
      const GetSTODetailsAPI = () =>{
        CommonAPI.GetSTODetails({StandingOrderId: StandingOrderId},(result) =>{   
            if(result){                    
              setMainCustomerName(result.savingsAccount?(result.savingsAccount.mainCustomer.title+result.savingsAccount.mainCustomer.firstName+" "+result.savingsAccount.mainCustomer.lastName):null);
              setBenename(result.beneName);
              setBeneBankAccountNum(result.bankAccNo);
              setBankAccountNum(result.savingsAccount?result.savingsAccount.accountNo:null);
              setFrequency(result.frequency==="Daily"?"D":result.frequency==="Weekly"?"W":result.frequency==="Monthly"?"M":result.frequency==="Quarter"?"Q":result.frequency==="Half Yearly"?"H":result.frequency==="Yearly"?"Y":null);
              setAmount( result.amount);
              setBeneBank(result.bankBr.bank.name);
              setBeneBranch(result.bankBr.name);
              setStartDate(result.startDate);
              setEndDate(result.endDate);
              setYourReference(result.reference);
              setBeneReference(result.beneReference);
              setStatus(result.status==="ACT"?"Active":result.status==="INA"?"Cancelled":result.status==="INI"?"Inactive":"");
              setReferenceNumber(result.stnoRef);
              setSummary(result.accTransSummery);
              setSuccessLoading(false);
              setRecurring(result.endDate?"R":"N")
              setAvialableBalance(result.savingsAccount?result.savingsAccount.avialableBalance:null,)
            } 
            if(result.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
      }

      const CheckFirstPassword = () =>{ 

        if(Amount<=0){
          setErrorMSG("Transfer amount less than 0");
        }else if(!Frequency){
          setErrorMSG("Select the Frequency");
        }else if(!Recurring){
          setErrorMSG("Select the Payment Method");
        }else{
        CommonAPI.CheckPassword({password:EnteredPassword},(results) =>{ 

         if(results.password==="true"){
             setErrorMSG();
             AmendSTOAPI();
         }else{
             setErrorMSG("Enter Correct Password");
         }
        })
      }    
     }
      const AmendSTOAPI = () =>{
        var StartDate = moment(StartDate).format("YYYY-MM-DD");
        var AmmendEndDate = "";
        if(Recurring==="N") {
            AmmendEndDate = ""
          } else {
            AmmendEndDate = EndDate?moment(EndDate).format("YYYY-MM-DD"):null
          }
        CommonAPI.AmmendStandingOrder({
            StandingOrderId:StandingOrderId,
            BeneBankAccountNum:BeneBankAccountNum,
            PayeeFrequency:Frequency,
            Amount:Amount,
            StartDate:StartDate,
            AmmendEndDate:AmmendEndDate,
        },(result)=>{
            if(result.message=="Success"){
                setSuccessMSG(true)
                }else{
                  setErrorMSG(result.message);
                }
              return result;
          
        })
      }
      
      if(SuccessMSG){
        return(
        <SuccessMsg ConfirmSuccess={SuccessMSG} 
        Close={props.toggle} head="SUCCESS" head2="" 
        contentline1="Your Standing Order Successfully Amended"
         />
         )
    }
  
        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>AMEND</p><br/>STANDING ORDER
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                        <Form.Label className="c-font block">
                        <b>SENDER DETAILS</b>
                        </Form.Label>
                    
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                            Account Number
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Label className="c-font">
                            {BankAccountNum}
                        </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                            Name
                        </Form.Label>
                        <Col sm={7} >
                            <Form.Label className="c-font">
                                {MainCustomerName}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                         Available Balance
                        </Form.Label>
                        <Col sm={7} >
                            <Form.Label className="c-font">
                            {parseFloat(AvialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                            </Form.Label>
                        </Col>
                    </Form.Group>
                    
                        <Form.Label className="c-font t-left">
                        <b>BENEFICIARY DETAILS</b>
                        </Form.Label>
                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Bank Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                           {BeneBank}
                        </Form.Label>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Account Number
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                           {BeneBankAccountNum}
                        </Form.Label>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Amount Transfer Rs.
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control 
                         value={Amount}
                         onChange={(e)=>{setAmount(e.target.value)}} 
                         className="form-h2" 
                         size="sm" type="email" 
                         placeholder="PHONE NUMBER" />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                        Payment Method
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                        value={Recurring}                       
                        onChange={(value)=>setRecurring(value.target.value)} 
                        size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="R">Set Up Recurring Transfer</option>
                            <option value="N">Set Up Recurring Transfer Until Further Notice</option>                            
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    {Recurring?
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                         Payment Date
                        </Form.Label>
                        <Col sm={7} >
                            <div className='d-flex flex-row align-items-center'>                                
                            <Form.Label className="c-font s-top2" >
                                {moment(StartDate).format("DD/MM/YYYY")}
                             </Form.Label>
                              <label className='lable l-width t-center'> To</label> 
                              {Recurring==="R"?
                              <DatePicker
                                  className="datepicker2"
                                  selected={EndDate}
                                  onChange={(e)=>setEndDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                              : Recurring==="N"?
                              <Form.Label className="c-font s-top2 t-right" >
                                  U.F.N
                              </Form.Label>
                              :
                              <Form.Label className="c-font s-top2" >
                              -
                              </Form.Label>
                           
                            }
                            </div>                  
                        </Col>
                    </Form.Group>
                    :null}
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                            Frequency
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select size="sm" 
                        value={Frequency}
                        onChange={(value)=>setFrequency(value.target.value)}
                        className="form-h2 ">
                            <option value="">-SELECT-</option>
                            <option value="M">Monthly</option>
                            <option value="D">Daily</option>
                            <option value="W">Weekly</option>
                            <option value="Q">Quarterly</option>
                            <option value="H">Half Yearly</option>
                            <option value="Y">Yearly</option>                           
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Password To Confirm Amend of STO
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control value = {EnteredPassword}                       
                            onChange={(text)=>setEnteredPassword(text.target.value)} 
                            className={!EnteredPassword?"form-h2 password-f":"form-h2"} size="sm" maxLength={8} type="password" 
                            placeholder="PASSWORD"  />
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p> 
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">  
                <Button className="btn-logout" onClick={()=>CheckFirstPassword()}>UPDATE</Button>
              </Modal.Footer>
            </Modal>
          );
    }

export default StoMaintain;